"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearHumidityAlert = exports.requestHumidityService = exports.clearWaterLeakAlert = exports.requestWaterLeakService = exports.clearPowerMonitorAlert = exports.requestPowerMonitorService = exports.orderFilter = exports.clearHvacFilterAlert = exports.requestFilterService = exports.updateServiceCompany = exports.createServiceCompany = exports.deleteCustomer = exports.updateCustomer = exports.createCustomer = exports.updateServiceRequest = exports.createServiceRequest = exports.updateSensorAlertAcknowledgedStateAnonymous = exports.updateSensorAlertAcknowledgedState = exports.updateSensorAlertStatus = exports.createSensorEvent = exports.deleteSensor = exports.updateSensorBranchCircuits = exports.updateSensor = exports.createSensorGroup = exports.createSensorLink = exports.createSensor = exports.associateHub = exports.deleteHub = exports.updateHubConfig = exports.updateHubAddress = exports.updateHub = exports.createHub = exports.updateCustomerBacklightPreferences = void 0;
exports.updateCustomerBacklightPreferences = `
  mutation UpdateCustomerBacklightPreferences(
    $customerId: ID!
    $preferences: BacklightPreferencesInput!
  ) {
    updateCustomerBacklightPreferences(customerId: $customerId, preferences: $preferences) {
      id
      name
      email
      backlightPreferences {
        color {
          r
          g
          b
        }
        pattern
      }
    }
  }
`;
exports.createHub = `
  mutation CreateHub($input: CreateHubInput!) {
    createHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;
exports.updateHub = `
  mutation UpdateHub($input: UpdateHubInput!) {
    updateHub(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;
exports.updateHubAddress = `
  mutation UpdateHubAddress($input: UpdateHubAddressInput!) {
    updateHubAddress(input: $input) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      street
      city
      state
      zip
      date
      time
      timezone
    }
  }
`;
exports.updateHubConfig = `
  mutation UpdateHubConfig($id: ID!, $config: String!) {
    updateHubConfig(id: $id, config: $config) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;
exports.deleteHub = `
  mutation DeleteHub($id: ID!) {
    deleteHub(id: $id) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
    }
  }
`;
exports.associateHub = `
  mutation AssociateHub($hubId: ID!) {
    associateHub(hubId: $hubId)
  }
`;
exports.createSensor = `
  mutation CreateSensor($input: CreateSensorInput!) {
    createSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.createSensorLink = `
  mutation CreateSensorLink($input: CreateSensorLinkInput!) {
    createSensorLink(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.createSensorGroup = `
  mutation CreateSensorGroup($input: CreateSensorGroupInput!) {
    createSensorGroup(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;
exports.updateSensor = `
  mutation UpdateSensor($input: UpdateSensorInput!) {
    updateSensor(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.updateSensorBranchCircuits = `
  mutation UpdateSensorBranchCircuits($input: UpdateSensorBranchCircuitsInput!) {
    updateSensorBranchCircuits(input: $input) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
    }
  }
`;
exports.deleteSensor = `
  mutation DeleteSensor($id: ID!) {
    deleteSensor(id: $id) {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.createSensorEvent = `
  mutation CreateSensorEvent($input: CreateSensorEventInput!) {
    createSensorEvent(input: $input) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      metadata
    }
  }
`;
exports.updateSensorAlertStatus = `
  mutation UpdateSensorAlertStatus($input: UpdateSensorAlertStatusInput!) {
    updateSensorAlertStatus(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.updateSensorAlertAcknowledgedState = `
  mutation UpdateSensorAlertAcknowledgedState($input: UpdateSensorAlertAcknowledgedStateInput!) {
    updateSensorAlertAcknowledgedState(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.updateSensorAlertAcknowledgedStateAnonymous = `
  mutation UpdateSensorAlertAcknowledgedStateAnonymous(
    $input: UpdateSensorAlertAcknowledgedStateInput!
  ) {
    updateSensorAlertAcknowledgedStateAnonymous(input: $input) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.createServiceRequest = `
  mutation CreateServiceRequest($input: CreateServiceRequestInput!) {
    createServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;
exports.updateServiceRequest = `
  mutation UpdateServiceRequest($input: UpdateServiceRequestInput!) {
    updateServiceRequest(input: $input) {
      id
      customerId
      hubId
      sensorId
      alertId
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      technicianName
      deviceLocation
      roomType
    }
  }
`;
exports.createCustomer = `
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.updateCustomer = `
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.deleteCustomer = `
  mutation DeleteCustomer($id: ID!) {
    deleteCustomer(id: $id) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.createServiceCompany = `
  mutation CreateServiceCompany($input: CreateServiceCompanyInput!) {
    createServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;
exports.updateServiceCompany = `
  mutation UpdateServiceCompany($input: UpdateServiceCompanyInput!) {
    updateServiceCompany(input: $input) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;
// HVAC Filter Alert Mutations
exports.requestFilterService = `
  mutation RequestFilterService($input: FilterServiceRequestInput!) {
    requestFilterService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
exports.clearHvacFilterAlert = `
  mutation ClearHvacFilterAlert($sensorId: ID!, $hubId: ID!) {
    clearHvacFilterAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.orderFilter = `
  mutation OrderFilter($input: FilterOrderRequestInput!) {
    orderFilter(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
// Power Monitor Alert Mutations
exports.requestPowerMonitorService = `
  mutation RequestPowerMonitorService($input: PowerMonitorServiceRequestInput!) {
    requestPowerMonitorService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
exports.clearPowerMonitorAlert = `
  mutation ClearPowerMonitorAlert($sensorId: ID!, $hubId: ID!) {
    clearPowerMonitorAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.requestWaterLeakService = `
  mutation RequestWaterLeakService($input: WaterLeakServiceRequestInput!) {
    requestWaterLeakService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      status
      requestedDate
      scheduledDate
      completedDate
      notes
      sensorId
      hubId
      createdAt
      updatedAt
    }
  }
`;
exports.clearWaterLeakAlert = `
  mutation ClearWaterLeakAlert($sensorId: ID!, $hubId: ID!) {
    clearWaterLeakAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
exports.requestHumidityService = `
  mutation RequestHumidityService($input: HumidityServiceRequestInput!) {
    requestHumidityService(input: $input) {
      id
      customerId
      customerName
      serviceCompanyId
      serviceCompanyName
      serviceType
      reason
      status
      priority
      hubId
      sensorId
      alertId
      notes
      accessInstructions
      deviceLocation
      roomType
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;
exports.clearHumidityAlert = `
  mutation ClearHumidityAlert($sensorId: ID!, $hubId: ID!) {
    clearHumidityAlert(sensorId: $sensorId, hubId: $hubId)
  }
`;
